import hexRgb from 'hex-rgb';

import styles from './HexViewer.module.scss';

// The colour of a band whose group has no entry in the colour map.
const FALLBACK_COLOUR = '#434343';

/**
 * The plot bands of the hex viewer: one for each calibration zone, coloured by the group of its folder, with a hidden label that describes the map.
 *
 * A band names its map by `id`, the map's name. No class carries the name, because a name can hold a space (`ip_prs_loss_ex_tube 2`), which a class
 * list cannot keep in one piece. The band's `className` is the single class `pointer`. Its label is found by `labelClass`, which is `label-b` and the
 * band's position in `calibrationZones`, and `label.className` is that same string: Highcharts puts it on the label's element, and the hover looks
 * the element up by it.
 *
 * The band has no events: the viewer adds them, because they need its context.
 *
 * @param calibrationZones [{id, groupName, from, to}] - one zone for each map, in order of calibration start. They are used as they are given.
 * @param maps [{id, title, titleDescription, mapSize, type}] - the map of a zone is the one with its id
 * @param colors {[group]: hex} - the colour of each group, already for the current theme
 * @param lightTheme boolean - not read here, because `colors` arrives resolved for the theme; it is part of the signature the plan gives
 * @returns [Band]
 */
export const buildBands = (calibrationZones, maps, colors, lightTheme) => calibrationZones.map((zone, index) => {
    const color = hexRgb(colors[zone.groupName.toLowerCase()] || FALLBACK_COLOUR);
    const map = maps.find(candidate => candidate.id === zone.id);
    const groupNameCapitalised = zone.groupName.charAt(0).toUpperCase() + zone.groupName.slice(1);
    const labelClass = `label-b${index}`;

    return {
        id: map.id,
        title: map.title,
        titleDescription: map.titleDescription,
        mapSize: map.mapSize,
        type: map.type,
        borderColor: 'white',
        borderWidth: 0,
        label: {
            useHTML: true,
            text: `<div class="${styles.info} bgTertiary highlightSecondary"><p><strong>Code Name:</strong> ${map.title}</p><p><strong>Description:</strong> ${map.titleDescription}</p><p><strong>Group Name:</strong> ${groupNameCapitalised}</p><p><strong>Type:</strong> ${map.type}</p><p><strong>Size: </strong> ${map.mapSize}</p></div>`,
            style: {
                display: 'none'
            },
            className: labelClass,
        },
        from: zone.from,
        to: zone.to,
        color: `rgba(${color.red}, ${color.green}, ${color.blue}, ${index % 2 ? 0.1 : 0.2})`,
        width: 1,
        className: 'pointer',
        labelClass,
        zIndex: 20,
    };
});
